import type { ClaimFlowDraft } from './claimDraftStorage'

export type OtherBranchParkedSubtype = 'weather' | 'fire' | 'theft'

export function vehicleParkedAtIncidentFlag(
  draft: ClaimFlowDraft | null | undefined,
  subtype: OtherBranchParkedSubtype
): boolean | null | undefined {
  if (!draft) return undefined
  switch (subtype) {
    case 'weather':
      return draft.weatherVehicleParkedAtIncident
    case 'fire':
      return draft.fireVehicleParkedAtIncident
    case 'theft':
      return draft.theftVehicleParkedAtIncident
  }
}

export function formatVehicleParkedAtIncidentYesNo(
  parked: boolean | null | undefined
): string {
  if (parked === true) return 'Yes'
  if (parked === false) return 'No'
  return 'NA'
}

/**
 * Confirm-page "Vehicle parked at incident" value for weather / fire / theft review rows.
 */
export function formatVehicleParkedAtIncidentReviewSummary(
  draft: ClaimFlowDraft | null | undefined,
  subtype: OtherBranchParkedSubtype
): string {
  return formatVehicleParkedAtIncidentYesNo(vehicleParkedAtIncidentFlag(draft, subtype))
}

/**
 * Confirm-page "Driver at incident" summary for weather / fire / theft when the parked question was asked.
 */
export function formatDriverAtIncidentReviewSummary(
  draft: ClaimFlowDraft | null,
  subtype: OtherBranchParkedSubtype,
  insuredDriverSummary: string
): string {
  if (vehicleParkedAtIncidentFlag(draft, subtype) === true) {
    return 'NA'
  }
  return insuredDriverSummary
}
